import { NavigationService, NavigationServiceModule } from '@b2b/common/services/navigation/navigation.service';
import { TODO } from '@b2b/types/core/utils';
import { StateService } from '@uirouter/angularjs';
import angular, { IScope, ITimeoutService } from 'angular';
import {
  AnnouncementsService,
  AnnouncementsServiceModule,
} from '@b2b/common/components/announcements/announcements.service';

LogoutController.$inject = ['$scope', '$state', '$timeout', 'AuthService', 'NavigationService', 'AnnouncementsService'];

function LogoutController(
  $scope: IScope & { logout: TODO },
  $state: StateService,
  $timeout: ITimeoutService,
  authService: TODO,
  navigationService: NavigationService,
  announcementsService: AnnouncementsService
) {
  const ctrl = {
    complete: function () {
      navigationService.reset();
      announcementsService.reset();
      authService.logout().then(ctrl.handler, ctrl.handler);
    },

    handler: function () {
      authService.destroy();

      $timeout(function () {
        $state.go('login.default');
        $scope.$emit('LogoutController::logout');
      }, 1000);
    },
  };

  $scope.logout = ctrl;
  ctrl.complete();
}

export const LogoutControllerModule = angular
  .module('acme.view.logout.controllers', [
    'ui.router',
    'acme.common.service.auth',
    NavigationServiceModule,
    AnnouncementsServiceModule,
  ])
  .controller('LogoutController', LogoutController).name;
